<template>
  <el-select
      v-model="selectedValue"
      placeholder="请先选择一级学科"
      :disabled="!parentValue"
      clearable
      filterable
  >
    <el-option
        v-for="item in flatList"
        :key="item.code"
        :label="item.name"
        :value="emitPath ? getFullPath(item.code) : item.code"
    />
  </el-select>
</template>

<script>
export default {
  name: "ZrDetailSelect",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      },
    },
    parentValue: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    // 是否输出全路径
    emitPath: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedValue: "",
      selectedCode: "",  // 保存选中的 code
    };
  },
  computed: {
    // 根据第一层选中值，筛选对应层级
    parentCode() {
      if (!this.parentValue) return null;
      const parts = this.parentValue.split(",");
      return parts[1] || parts[0];
    },

    // 获取父级路径部分（用于拼接完整路径）
    parentPath() {
      if (!this.parentValue) return "";
      const parts = this.parentValue.split(",");
      // 返回前两层：02,0202
      return parts.slice(0, 2).join(",");
    },

    // 通用的扁平化列表（支持三层/四层/任意层）
    flatList() {
      if (!this.treeData || !this.parentCode) return [];

      // 找到 parentCode 对应的节点
      const findNode = (data, code) => {
        for (const item of data) {
          if (item.code === code) {
            return item;
          }
          if (item.children) {
            const found = findNode(item.children, code);
            if (found) return found;
          }
        }
        return null;
      };

      const targetNode = findNode(this.treeData, this.parentCode);
      if (!targetNode || !targetNode.children) return [];

      // 收集最后一层的所有节点
      const collectLastLevel = (nodes) => {
        const result = [];

        for (const node of nodes) {
          if (!node.children || node.children.length === 0) {
            result.push(node);
          } else {
            result.push(...collectLastLevel(node.children));
          }
        }

        return result;
      };

      return collectLastLevel(targetNode.children);
    },
  },
  methods: {
    // 获取完整路径：父级路径 + 当前 code
    getFullPath(code) {
      if (!this.parentPath) return code;
      return `${this.parentPath},${code}`;
    },
  },
  watch: {
    value: {
      handler(v) {
        if (!v) {
          this.selectedValue = "";
          this.selectedCode = "";
          return;
        }

        // 解析传入的值，提取 code 和完整路径
        if (this.emitPath && v.includes(",")) {
          const parts = v.split(",");
          this.selectedCode = parts[parts.length - 1];
          this.selectedValue = v;
        } else {
          this.selectedCode = v;
          this.selectedValue = this.getFullPath(v);
        }
      },
      immediate: true,
    },
    selectedValue(v) {
      this.$emit("change", v || "");
    },
    parentValue() {
      // 当父级变化时，清空当前选择
      this.selectedValue = "";
      this.selectedCode = "";
      this.$emit("change", "");
    },
  },
};
</script>
